export const getFetchLeadUrl = ({ leadId }: { leadId: string }) =>
  `leads/${leadId}`;
